export default __webpack_public_path__ + "static/media/homeright.658a0a02.svg";